import axiosInstance from "../Interceptor";

export const getVendorProfileApi = (data) => {
  //   console.log(data, 'from api');



  return axiosInstance
    .get(`users/api/v1/vendor/${data}/`)
    .then((res) => {
      // console.log(res);
      return res;
    })
    .catch((err) => {
      // console.log(err);
      return err;
    });
};
